
import DisconnectComponent from 'app/modules/step-engine/ui/components/common/disconnect/disconnect-component';
import React from 'react';
import { useSelector } from 'react-redux';
import '../../../app/app.scss';
import { ErrorResponseDTO } from '../model/ErrorResponseDTO.model';
import { IRootState } from '../reducers';



export const InternalServerError = (props) => {
    const error: ErrorResponseDTO = props.error;
    const { isMobile } = useSelector((state: IRootState) => state.cms);

    return (
        <>
            <div className="error-page" >
                {!isMobile &&
                    <div className="row justify-content-center">
                        <div className="col-md-1 offset-md-11">
                            <DisconnectComponent logoutFromError={true} />
                        </div>
                    </div>
                }
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <p className="error-page-title">Oups, une erreur s&apos;est produite. </p>
                        <p className="error-page-subtitle">Veuillez rafraîchir la page ou réessayer un peu plus tard.</p>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <img className="align-middle" src="content/images/illu_oups.svg" />
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <p className="_text">Merci de bien vouloir nous excuser.</p>
                    </div>
                </div>
                {process.env.NODE_ENV === 'development' ? (
                    <>
                        <br />
                        <p className="_message">{error?.type}</p>
                        <br />
                        {error?.message}
                        <br />
                        <ul className="_details_error">
                            {error?.details?.map((e, i) => {
                                return (
                                    <li key={i}>
                                        {e}
                                    </li>
                                )
                            })}
                        </ul>
                    </>
                ) : undefined}
            </div>
        </>
    );
};

export default InternalServerError;
